import { COMMON_CONSTANTS } from '../constants/common.constants';

export interface AuthConfig {
  enabled: boolean;
  tokenKey: string;
  tokenPrefix: string;
  defaultRequiresAuth: boolean;
  public: { apis: string[]; patterns: string[] };
  hybrid: { apis: string[]; patterns: string[] };
  fileUpload: { apis: string[]; patterns: string[] };
}

export const authConfig: AuthConfig = {
  enabled: true,
  tokenKey: COMMON_CONSTANTS.JWT_TOKEN_KEY,
  tokenPrefix: COMMON_CONSTANTS.JWT_TOKEN_PREFIX,
  defaultRequiresAuth: true,
  public: {
    /** Magic-link only: `GET …/auth/session/validate/:id` — must NOT match `…/agentic-ai/session/validate` (JWT gate). */
    apis: ['auth/session/validate'],
    patterns: [],
  },
  hybrid: { apis: [], patterns: [] },
  fileUpload: { apis: [], patterns: [] },
};

export function isPublicEndpoint(url: string): boolean {
  if (authConfig.public.apis.some((api) => url.includes(api))) return true;
  return authConfig.public.patterns.some((pattern) => new RegExp(pattern).test(url));
}

export function isFileUploadEndpoint(url: string): boolean {
  if (authConfig.fileUpload.apis.some((api) => url.includes(api))) return true;
  return authConfig.fileUpload.patterns.some((pattern) => new RegExp(pattern).test(url));
}

export function isHybridEndpoint(url: string): boolean {
  if (authConfig.hybrid.apis.some((api) => url.includes(api))) return true;
  return authConfig.hybrid.patterns.some((pattern) => new RegExp(pattern).test(url));
}
